import { render, staticRenderFns } from "./ExpandedView.vue?vue&type=template&id=52d581d8&scoped=true&"
import script from "./ExpandedView.vue?vue&type=script&lang=ts&"
export * from "./ExpandedView.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandedView.vue?vue&type=style&index=0&id=52d581d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d581d8",
  null
  
)

export default component.exports